export default function pointerEventsControl(edit) {
  if (edit === '') {
    return 'none'
  } else {
    return 'all'
  }
};
